<template>
  <div class="store-settings">
    <h2 class="font-semi-bold mb-4">Store Settings</h2>
    <el-select
      v-model="outlet"
      filterable
      style="max-width: 350px; min-width: 250px"
      placeholder="Select Store"
      size="small"
      @change="settingsStoreUpdated"
      >
      <el-option
        v-for="(item, index) in outletLists.filter(el => el.type != 'head_office')"
        :key="index"
        :value="item.id"
        :label="sentenceCase(item.name)"
      >
        {{ item.name | toTitleCase }}
      </el-option>
    </el-select>
    <el-tabs v-model="activeName" :before-leave="handleBeforeLeave" @tab-click="handleClick">
      <el-tab-pane label="Store Details" name="loc">
        <el-card class="br-12">
          <StoreDetails v-if="activeName == 'loc'" />
        </el-card>
        <el-card :v-loading="isLoading" class="br-12 mt-4">
          <!-- <h4 class="my-2">
            {{
              (outlet ? getOutletName(outlet) : "No store selected")
                | toTitleCase
            }}
          </h4> -->
          <h2 class="my-2">Sections</h2>
          <el-row v-if="sections.length == 0 && outlet" :gutter="20" class="mb-4">
            <el-col :span="24">
              <p>Sections are not available</p>
            </el-col>
          </el-row>
          <div class="col-container">
            <div
              v-for="(el, key) in sections.filter(el => el.name != 'Location')"
              :key="'outlet-sections-' + key"

              class="col-item mb-2"
              :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"
            >
              <el-card
                class="br-12"
                style="height: 100%; min-height: 235px; padding: 10px; padding-right: 15px; border-radius: 12px;"
                :style="el.enabled ? 'background: #FFF9F4; border-color: #F9A168;' : ''"
              >
                <el-row :gutter="20" class="mt-4">
                  <el-col :span="18">
                    <p class="font-bold">{{ el.name }}</p>
                  </el-col>
                  <el-col :span="6">
                    <el-row :gutter="20">
                      <el-col :span="12" class="text-center">
                        <img
                          v-if="!el.editable"
                          src="../../../../../assets/icons/edit-icon.svg"
                          width="12"
                          :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"
                          @click="(hasAdminAccess || postOnboardingAccess)  ? el.editable = true : ''"
                        />
                        <!-- <i
                          v-else-if="el.editable"
                          class="el-icon-circle-check cursor-pointer"
                          @click="el.editable = false; addOrUpdateSection();"
                        ></i> -->
                      </el-col>
                      <el-col :span="12" class="text-left">
                        <span :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']">
                          <el-switch
                            v-model="el.enabled"
                            size="mini"
                            active-color="#e29d5a"
                            :disabled="!(hasAdminAccess || postOnboardingAccess) "
                            @change="(hasAdminAccess || postOnboardingAccess)  ? addOrUpdateSection(el.id) : ''"
                          ></el-switch>
                        </span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="mt-4">
                  <el-col :span="24">
                    <p v-if="!el.editable">
                      {{ el.section_open_time | timeFormat }} -
                      {{ el.section_close_time | timeFormat }}
                    </p>
                    <el-row v-else-if="el.editable" :gutter="20">
                      <el-col :span="12">
                        <p class="mb-2">Start Time</p>
                        <el-time-select
                          v-model="el.section_open_time"
                          style="width: 100%"
                          :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '23:30',
                          }"
                          placeholder="Select time"
                        >
                        </el-time-select>
                      </el-col>
                      <el-col :span="12">
                        <p class="mb-2">End Time</p>
                        <el-time-select
                          v-model="el.section_close_time"
                          style="width: 100%"
                          :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '23:30',
                          }"
                          placeholder="Select time"
                        >
                        </el-time-select>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="mt-4">
                  <el-col :span="24">
                    <p class="font-bold mb-2 text-xs">Coverage Activities</p>
										<template v-for="(itemSec, indexSec) in el.setups_for_section">
											<el-popover
											  v-if="itemSec.coverage_hours_defined"
												:key="'item-pri-'+indexSec"
												placement="right"
												width="40"
									      popper-class="action-popover"
												trigger="hover"
                        :disabled="!itemSec.enabled || !(hasAdminAccess || postOnboardingAccess) "
											>
												<el-row v-if="itemSec.enabled" :gutter="20" :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']">
													<el-col :span="24" class="text-center">
														<span>
															<img src="../../../../../assets/icons/edit-icon.svg" width="12" :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"
																@click="(hasAdminAccess || postOnboardingAccess)  ? openSectionalCoverageActivity(itemSec.function, itemSec.store_section) : ''" />
														</span>
													</el-col>
												</el-row>
                        <span slot="reference" :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']">
                          <span @click="(hasAdminAccess || postOnboardingAccess) && el.enabled  ? (itemSec.enabled = !itemSec.enabled, addOrUpdateSection()) : ''">
                            <primary-tag v-if="itemSec.enabled">
															<span class="pr-1" :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-check"></i></b></span>{{ itemSec.function_name }}
														</primary-tag>
                            <secondary-tag v-else-if="!itemSec.enabled">
															<span class="pr-1" :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"><b><i class="el-icon-close"></i></b></span>{{ itemSec.function_name }}
														</secondary-tag>
                          </span>
                        </span>
											</el-popover>
										</template>
                  </el-col>
                  <el-col :span="24">
                    <el-button
                        v-if="el.editable"
                        type="warning"
                        size="medium"
                        class="custom_save_btn float-right"
                        :class="[(hasAdminAccess || postOnboardingAccess)  ? 'cursor-pointer' : 'cursor-not-allowed']"
                        round
                        @click="(hasAdminAccess || postOnboardingAccess)  ? (el.editable = false, addOrUpdateSection()) : ''"
                      >SAVE</el-button>
                    <el-button
                        v-if="el.editable"
                        type="warning"
                        size="medium"
                        class="custom_cancel_btn float-right"
                        round
                        @click="el.editable = false"
                      >CANCEL</el-button>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </div>
        </el-card>
				<!-- Store Non Coverage Activities -->
				<el-row :gutter="20" class="mt-4">
					<el-col :span="24">
						<store-non-coverage-activities />
					</el-col>
				</el-row>
        <div class="relative">
          <el-row :gutter="20" class="mt-4 ns-card-settings">
          <el-col :span="24" class="text-right">
            <!-- <el-button
              type="warning"
              plain
              icon="el-icon-circle-plus-outline"
              class="primary-settings-button__save"
              size="small"
              @click="saveStoreDetailsData"
            >Save</el-button> -->
            <el-button
              type="warning"
              plain
              class="primary-settings-button__save"
              size="small"
              :disabled="!hasAdminAccess && !postOnboardingAccess"
              @click="(hasAdminAccess || postOnboardingAccess) ? show_store_details_save_confirmation = true : ''"
            >Save</el-button>
          </el-col>
        </el-row>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="Section" name="section">
        
      </el-tab-pane> -->
			<el-tab-pane label="Guidelines/Policy" name="guidelines">
				<Staff v-if="activeName == 'guidelines'" />
      </el-tab-pane>
      <el-tab-pane label="Team" name="team">
        <!-- <Team v-if="locations.length && activeName == 'team'" @beforeChangeTab="beforeChangeTab"/> -->
        <Team v-if="activeName == 'team'" @beforeChangeTab="beforeChangeTab"/>
      </el-tab-pane>
    </el-tabs>
		<add-or-edit-non-coverage-activity></add-or-edit-non-coverage-activity>
    <!-- Daily and weekly view merged non-coverage activity modal -->
    <combined-non-coverage-activity></combined-non-coverage-activity>

    <store-section-edit-modal></store-section-edit-modal>
    <add-or-edit-coverage-activities></add-or-edit-coverage-activities>
    <el-dialog
      v-if="outlet"
      class="daily-activity-modal"
      width="100"
      :show-close="false"
      :fullscreen="true"
      :visible.sync="daily_activity_view"
    >
      <template v-if="daily_activity_view">
        <non-coverage-activity-daily-view
          :store-id="outlet"
          :day-list="daysList"
          :all-function-list="functions"
          @closeActivityView="openDailyView"
        ></non-coverage-activity-daily-view>
      </template>
    </el-dialog>
    <grouped-coverage-activity-list></grouped-coverage-activity-list>
    <add-or-edit-updated-coverage-activity></add-or-edit-updated-coverage-activity>
		<filtered-daily-activities></filtered-daily-activities>
    <store-details-save-confirmation />
    <el-dialog title="Under process" :visible.sync="store_processing_completed" width="35%"
      custom-class="auto-scheduling-dialog">
      <div class="p-2 mt-4 text-center">
        <img src="../../../../../assets/illustration/wait.svg" style="width: 200px" alt="" />
        <div style="font-size: 14px; line-height: 19px" class="mt-3">
          System is updating the ideal labours. Please check the updated forecast after some time. We will inform you with an email.
        </div>
      </div>
      <div slot="footer" class="dialog-footer mt-2">
        <a class="font-semibold cursor-pointer mr-6" @click="store_processing_completed = false">Okay</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Team from "./StoreTeams.vue";
import AddOrEditNonCoverageActivity from "../companySettings/AddOrEditNonCoverageActivity.vue";
import StoreDetails from "../../storeSettings/storeDetails/StoreDetails.vue";
import settingsMixin from "../../../../../../mixins/settingsMixin";
import CombinedNonCoverageActivity from "../companySettings/CombinedNonCoverageActivity.vue";
import CombinedNonCoverageActivityOld from "../companySettings/CombinedNonCoverageActivityOld.vue";
import StoreSectionEditModal from "./StoreSectionEditModal.vue";
import AddOrEditCoverageActivities from "../companySettings/AddOrEditCoverageActivities.vue";
import NonCoverageActivityDailyView from "./NonCoverageActivityDailyView.vue";
import GroupedCoverageActivityList from "../companySettings/GroupedCoverageActivityList.vue";
import AddOrEditUpdatedCoverageActivity from "../companySettings/AddOrEditUpdatedCoverageActivity.vue";
import StoreNonCoverageActivities from './StoreNonCoverageActivities.vue';
import PrimaryTag from "../companySettings/PrimaryTag.vue";
import SecondaryTag from '../companySettings/SecondaryTag.vue';
import FilteredDailyAcitivities from './FilteredDailyAcitivities.vue';
import Staff from "../../storeSettings/staff/Staff.vue";
import StoreDetailsSaveConfirmation from "./StoreDetailsSaveConfirmation.vue";
import { EventBus } from "../../../../../eventBus";
import {mapState, mapActions} from 'vuex';
export default {
  name: "StoreSettings",
  components: {
    Team,
		AddOrEditNonCoverageActivity,
    StoreDetails,
    CombinedNonCoverageActivity,
    CombinedNonCoverageActivityOld,
    StoreSectionEditModal,
    AddOrEditCoverageActivities,
    GroupedCoverageActivityList,
    AddOrEditUpdatedCoverageActivity,
    NonCoverageActivityDailyView,
		StoreNonCoverageActivities,
		PrimaryTag,
		SecondaryTag,
		'filtered-daily-activities': FilteredDailyAcitivities,
		Staff,
    StoreDetailsSaveConfirmation,
  },
  mixins: [settingsMixin],
  data() {
    return {
      activeName: "loc",
      value1: false,
      isLoading: false,
      is_bulk_edit_on: false,
    };
  },
  computed: {
    ...mapState('LabourPlanning', ['isTeamDataChanged']),
  },
  watch: {
		async outlet(newValue, oldValue) {
			if (newValue) {
				await this.getStoreDepartmentsAndFunctions();
				await this.getSections();
				await this.getDailyActivities();
        await this.getGroupedCoverageActivityList();
				await this.getDesignation();
				await this.getNonCoverageActivities();
        this.generalSettingsStore = newValue;
        localStorage.setItem('store', newValue);
			}
		},
    updateSectionActivity(newValue, oldValue) {
      if(newValue == false) {
        this.resetSelectedNonCoverageActivity();
      }
    }
	},
  beforeMount() {
    if(this.$route.query.tab && ['team', 'guidelines', 'section', 'loc'].includes(this.$route.query.tab)) {
      this.activeName = this.$route.query.tab;
    }
  },
  async mounted() {
    this.isAdmin = localStorage.getItem("user_access_level");
    if(localStorage.getItem('store')) {
      this.outlet = localStorage.getItem('store');
    }
    // setTimeout(() => {
      await this.callReqApi();
    // }, 500);
  },
  methods: {
    ...mapActions('LabourPlanning', ['setTeamDataChanges']),
    toggleStoreDetailsSavePopup() {
			this.show_store_details_save_confirmation = !this.show_store_details_save_confirmation;
		},
    async callReqApi(){
      await this.getLocations();
      await this.getAllOutlets();
      await this.getAllStoreNonCoverageActivities();
      await this.getOrderTypes();
      await this.getDepartmentList();
      await this.getAllCategory();
      await this.getAllSubCategories();
    },
    handleClick(tab, event) {
      // console.log(this.activeName);
      if(this.$route.query.tab) {
        let query = this.$route.query;
        if(query) {
          this.$route.query = {...query, tab: this.activeName};
        }
      }
    },
    handleBeforeLeave(tab, next) {
      // EventBus.$emit('teamTabChanged')
      return new Promise((resolve, reject) => {
        if (this.isTeamDataChanged) {
          this.$confirm("Do you wish to continue without saving?", "Alert", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          })
            .then(() => {
              resolve();
              this.setTeamDataChanges(false);
            })
            .catch(() => {
              reject();
              this.setTeamDataChanges(false);
            });
        } else  {
          resolve();
        }
      });
    },
    beforeChangeTab(condition){
      this.is_bulk_edit_on = condition;
    },
    saveSections() {
      this.isLoading = true;
      this.addOrUpdateSection().then(res => {
        this.getSections();
      }).catch(error => {
        console.error(error);
      }).finally(result => {
        this.isLoading = false;
      })
    },
    settingsStoreUpdated(event) {
      this.generalSettingsStore = event;
      localStorage.setItem("store_id", event);
      localStorage.setItem("store", event);
      this.$store.commit("LabourPlanning/SET_STORE_NAME", event);
			EventBus.$emit("updateStoreData", event);
    },
    confirmPopup() {
      this.$confirm(`Select your choice`, "Save Store Details", {
        confirmButtonText: "Save and Update labor hour",
        cancelButtonText: "Save",
        dangerouslyUseHTMLString: true
      }).then(() => {
        

      })
      .catch(() => {

      })
    }
  },
};
</script>

<style lang="scss">
.store-settings {
  .combined-non-coverage-activities {
    .el-dialog__header {
      // display: none !important;
      background: #ffff !important;
    }
    .dialog-heading {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      color: #333333;
    }
  }
  .el-table td.el-table__cell div.cell {
    text-align: left !important;
		font-size: 14px !important;
  }
  .el-table td.el-table__cell div {
		text-transform: capitalize !important;
	}
  .sectional-heading {
    /* text-align: center; */
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    margin: 10px 0;
    /* text-decoration: underline;
    font-style: italic; */
    margin-bottom: 20px;
    font-weight: 600;
  }
  .daily-activity-modal{
    .el-dialog__header{
      background-color: #fff;
      .el-dialog__title{
        color: #000;
      }
    }
  }
  .StoreSettings .daily-activity-modal  .el-dialog {
    margin-top: 0px !important;
  }
  .col-container {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    grid-gap: 10px;
    .col-item {
      height: 100%;
    }
  }
  .primary-settings-button {
		color: #F9A168 !important;
		border-color: #F9A168 !important;
		background: #FFFFFF !important;
		border-radius: 12px !important;
		min-width: 100px !important;
	}
	.primary-settings-button:hover {
		color: #FFFFFF !important;
		border-color: #F9A168 !important;
		background: #F9A168 !important;
	}
	.primary-settings-button__save {
		color: #FFFFFF !important;
		border-color: #F9A168 !important;
		background: #F9A168 !important;
		border-radius: 12px !important;
		min-width: 100px !important;
	}
	.primary-settings-button__save:hover {
		color: #F9A168 !important;
		border-color: #F9A168 !important;
		background: #FFFFFF !important;
	}
	.primary-settings-button__save:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
  @media (max-width: 991px) {
    .col-container {
      display: grid;
      grid-template-columns: auto auto;
      grid-gap: 10px;
      .col-item {
        height: 100%;
      }
    }
  }
  @media (max-width: 768px) {
    .col-container {
      display: grid;
      grid-template-columns: auto;
      grid-gap: 10px;
      .col-item {
        height: 100%;
      }
    }
  }
  .groupped-act-item {
    padding-bottom: 8px;
    font-size: 12px;
  }
  .el-table th > .cell {
    text-align: left !important;
  }
  .el-dialog__header {
		// display: none !important;
	}
}
.action-popover {
  min-width: fit-content !important;
  width: auto !important;
	text-align: center !important;
}
.custom_save_btn {
	color: #FFFFFF !important;
	border-color: #F9A168 !important;
	background: #F9A168 !important;
	border-radius: 99px !important;
	min-width: 65px !important;
	padding: 8px 5px !important;
	font-size: 12px !important;
	font-weight: bold !important;
	cursor: pointer !important;
}
.custom_cancel_btn {
	color: #F9A168 !important;
	border-color: #F9A168 !important;
	background: #fff !important;
	border-radius: 99px !important;
	min-width: 65px !important;
	padding: 8px 5px !important;
	font-size: 12px !important;
	font-weight: bold !important;
	cursor: pointer !important;
  margin: 0 5px;
}
.custom_save_btn:hover {
	color: #F9A168 !important;
	border-color: #F9A168 !important;
	background: #FFFFFF !important;
}
.custom-class-groupped-coverage-section .el-dialog__header{
  display: none;
}

.ns-card-settings{
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  // border-radius: 12px !important;
  // margin: 0 auto;
  padding: 15px 25px;
  position: fixed;
  width: 97%;
  box-sizing: border-box;
  left: 73px;
  bottom: 0;
  z-index: 1;

  @media (max-width: 1150px) {
    padding: 15px 45px;
  }
  @media (max-width: 1390px) {
    padding: 15px 40px;
  }
}
</style>
